import i18n from '@/i18n';

// Regra da senha no idioma do cardápio (o texto em português é o de sempre).
export const senhaRegra = () => i18n.t('conta.senhaRegra');

export const getPasswordError = password => {
    if (typeof password !== 'string' || password.length < 8) {
        return senhaRegra();
    }

    if (!/[a-zA-ZÀ-ÿ]/.test(password) || !/\d/.test(password)) {
        return senhaRegra();
    }

    return false;
};
